/**
 * Turkish lira.
 */
export var TRY = {
  code: 'TRY',
  base: 10,
  exponent: 2
};